export namespace RuleValueConstants {
  // Names
  export const MINUTES_BEFORE_PICKUP_TIME_TO_SHOW_EN_ROUTE_BUTTON: string = 'minutes before pickup time to show en route button';
  export const MINIMUM_DISTANCE_BETWEEN_USER_LOCATION_UPDATES_NAME: string = 'minimum distance between driver location updates';
  export const MINIMUM_TIME_BETWEEN_USER_LOCATION_UPDATES_NAME: string = 'min time between driver location updates';
  export const MAXIMUM_MINUTES_BETWEEN_PERIOD_3_ROUTE_NODES_NAME: string = 'max minutes between period 3 route nodes';
  export const PASSWORD_REGEX: string = 'password validation regex';
  export const MAX_VEHICLE_AGE_IN_YEARS: string = 'max vehicle age years';
  export const PASSWORD_REGEX_DEFAULT: string = '(?=^.{6,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$';
  export const MINIMUM_DRIVER_BANK_BALANCE_AFTER_PAYOUT: string = 'minimum driver bank balance after payout';
  export const PAYOUT_FEE: string = 'payout fee';
  export const MAXIMUM_WEEKLY_PAYOUT_TOTAL: string = 'maximum weekly payout total';
  export const MINUTES_AFTER_ON_DEMAND_DRIVER_SELECTION_TO_ALLOW_CANCELLATIONS: string =
    'minutes after on demand driver selection to allow cancellations';
  export const RADIUS_IN_MILES_FOR_TRANSIT_PROGRAM_ACCEPTANCE: string = 'radius in miles for transit program acceptance';
  export const OFFLINE_ROUTE_NODE_BATCH_SIZE: string = 'offline route node batch size';
  export const FRONT_END_REQUEST_TIMEOUT_SECONDS: string = 'front end request timeout seconds';
  export const DAYS_BEFORE_APP_DEPRECATION_TO_WARN_USER = 'days before app deprecation to warn user';

  export const DAYS_OF_RANDOM_TEST_PERIOD: string = 'number of days in random screening period';
  export const RANDOM_DRUG_PERCENTAGE_FOR_DRIVERS: string = 'yearly percentage of active drivers to be selected for random drug screenings';
  export const RANDOM_DRUG_AND_ALCOHOL_PERCENTAGE_FOR_DRIVERS: string = 'random drug and alcohol percentage for drivers';
  export const RANDOM_DRUG_BUFFER_PERCENTAGE: string = 'random drug screening buffer percentage';
  export const RANDOM_DRUG_AND_ALCOHOL_BUFFER_PERCENTAGE = 'random drug and alcohol screening buffer percentage';
  export const MAX_NUMBER_OF_DAYS_IN_RANDOM_SCREENING_PERIOD = 'max number of days in random screening period';
  export const CALIFORNIA_MILEAGE_BEFORE_NEXT_INSPECTION = 'California mileage before next inspection';
  export const MAX_RIDE_EXECUTION_GEOFENCE_DISTANCE_METERS = 'max ride execution geofence distance meters';
  export const DAYS_TO_WAIT_BETWEEN_PROMPTING_RIDER_TO_CLAIM_ORG_RIDERS = 'days to wait between prompting rider to claim org riders';

  export const MAX_DAYS_AHEAD_TO_SCHEDULE_SUBSCRIPTION_START = 'max days ahead to schedule subscription start';
  export const MAX_DAYS_AFTER_START_DATE_FOR_RIDE_SUBSCRIPTION_END = 'max days after start date for ride subscription to end';

  export const AUTHORIZE_NET_VALIDATION_MODE: string = 'authorize.net validation mode';

  export const MINUTES_TO_DELAY_PICK_UP_TIME_FOR_RIDE_BACKUP_SELF_SERVICE: string =
    'minutes to delay pick up time for ride backup self service';

  export const HOURS_AFTER_PICK_UP_TIME_TO_ALLOW_MANUAL_RESERVATION_STATUS_UPDATE: string =
    'hours after pick up time to allow manual reservation status update default';
  // Minnesota
  export const MINNESOTA_AVERAGE_DURATION_METERS_PER_SECOND: string = 'minnesota average duration meters per second';
  export const MINNESOTA_AVERAGE_P2_DISTANCE_METERS: string = 'minnesota average p2 distance meters';
  export const MINNESOTA_AVERAGE_P2_DURATION_SECONDS: string = 'minnesota average p2 duration seconds';

  // Defaults
  export const MINUTES_BEFORE_PICKUP_TIME_TO_SHOW_EN_ROUTE_BUTTON_DEFAULT: number = 60;
  export const MINUTES_AFTER_ON_DEMAND_DRIVER_SELECTION_TO_ALLOW_CANCELLATIONS_DEFAULT: number = 2;
  export const MINIMUM_DISTANCE_BETWEEN_USER_LOCATION_UPDATES_DEFAULT: number = 75;
  export const MINIMUM_TIME_BETWEEN_USER_LOCATION_UPDATES_DEFAULT: number = 5;
  export const MAXIMUM_MINUTES_BETWEEN_PERIOD_3_ROUTE_NODES_DEFAULT: number = 10;
  export const MAX_VEHICLE_AGE_IN_YEARS_DEFAULT: number = 11;
  export const OFFLINE_ROUTE_NODE_BATCH_SIZE_DEFAULT: number = 25;
  export const MAX_RIDE_EXECUTION_GEOFENCE_DISTANCE_METERS_DEFAULT = 300;
  export const FRONT_END_REQUEST_TIMEOUT_SECONDS_DEFAULT: number = 30;
  export const DAYS_BEFORE_APP_DEPRECATION_TO_WARN_USER_DEFAULT = 3;
  export const MINUTES_TO_DELAY_PICK_UP_TIME_FOR_RIDE_BACKUP_SELF_SERVICE_DEFAULT: number = 15;
  export const HOURS_AFTER_PICK_UP_TIME_TO_ALLOW_MANUAL_RESERVATION_STATUS_UPDATE_DEFAULT: number = 12;
}
